var _path, _path2, _path3, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContentful(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 289,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 289",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m87.333315 200.77659c-15.3058387-14.405495-24.3092732-34.213051-24.3092732-56.721637 0-22.508587 9.0034345-42.316143 23.4089298-56.721638 12.6048083-12.6048083 12.6048083-32.4123643 0-45.0171727-12.6048084-12.6048083-32.4123644-12.6048083-45.0171727 0-25.2096167 26.1099602-41.4157989 62.1236987-41.4157989 101.7388107s16.2061822 75.62885 42.3161423 101.73881c12.6048084 12.604808 32.4123644 12.604808 45.0171727 0 11.7044649-12.604808 11.7044649-32.412364 0-45.017173z",
    fill: "#fae501"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m87.333315 87.333315c14.405495-15.3058387 34.213051-24.3092732 56.721638-24.3092732 22.508586 0 42.316142 9.0034345 56.721637 23.4089298 12.604809 12.6048083 32.412365 12.6048083 45.017173 0 12.604808-12.6048084 12.604808-32.4123644 0-45.0171727-26.10996-25.2096167-62.123698-41.4157989-101.73881-41.4157989s-75.6288505 16.2061822-101.7388107 42.3161423c-12.6048083 12.6048084-12.6048083 32.4123644 0 45.0171727 12.6048084 11.7044649 32.4123644 11.7044649 45.0171727 0z",
    fill: "#4fb5e1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m200.77659 200.77659c-14.405495 15.305839-34.213051 24.309273-56.721637 24.309273-22.508587 0-42.316143-9.003434-56.721638-23.408929-12.6048083-12.604809-32.4123643-12.604809-45.0171727 0-12.6048083 12.604808-12.6048083 32.412364 0 45.017172 26.1099602 25.209617 62.1236987 41.415799 101.7388107 41.415799s75.62885-16.206182 101.73881-42.316142c12.604808-12.604808 12.604808-32.412364 0-45.017173-12.604808-11.704465-32.412364-11.704465-45.017173 0z",
    fill: "#f05751"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.824729,
    cy: 64.824729,
    fill: "#0681b6",
    rx: 31.512021,
    ry: 31.512021
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.824729,
    cy: 223.285177,
    fill: "#cd4739",
    rx: 31.512021,
    ry: 31.512021
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentful);
export default __webpack_public_path__ + "static/media/contentful.760b6a1bf91fe39645e9a9148945cd0a.svg";
export { ForwardRef as ReactComponent };